import { getSessionIdToken } from '../auth/apiAuth';
import axios from 'axios';

const INTEGRATIONS_ENDPOINT = `${process.env.REACT_APP_API_BASE_URL}/integrations`;
const PIM_PROXY_ENDPOINT    = `${process.env.REACT_APP_API_BASE_URL}/pim-proxy`;

export const fetchIntegrations = async (setError, projectValue) => {
    const [customer, project_name] = projectValue.split('/').slice(0, 2);
    setError(null);
    try {
        const response = await axios.get(INTEGRATIONS_ENDPOINT, {
            headers: {
                customer,
                project_name,
                Authorization: await getSessionIdToken(),
                'content-type': 'application/json',
            },
        });
        return response.data.services || [];
    } catch (err) {
        setError('An error occurred. Please retry again.');
        return null;
    }
};

/**
 * Chiama la Lambda /pim-proxy per ottenere risorse da un PIM di terze parti.
 * La Lambda gestisce autenticazione e chiamate API server-side (no CORS).
 *
 * @param {Function} setError
 * @param {string}   projectValue  - es. "pagination/akeneo-demo-api"
 * @param {string}   service       - es. "akeneo" (vedi SERVICES nella Lambda)
 * @param {string}   resource      - es. "channels" | "locales" | "families"
 * @returns {Array|null}           - array di { code, label } oppure null se errore
 */
export const fetchPimResource = async (setError, projectValue, service, resource) => {
    const [customer, project_name] = projectValue.split('/').slice(0, 2);
    try {
        const resp = await axios.get(PIM_PROXY_ENDPOINT, {
            headers: {
                customer,
                project_name,
                service,
                resource,
                Authorization: await getSessionIdToken(),
                'content-type': 'application/json',
            },
        });
        return resp.data.items || [];
    } catch (err) {
        const msg = err.response?.data?.error || err.message || 'Unknown error';
        setError(`Error: ${msg}`);
        return null;
    }
};
